module.exports = __webpack_public_path__ + "static/media/elephant_emboss-min.30a98d9e.jpg";